export default {"src":"/_next/static/media/disc-wheels.96f30fff.svg","height":353,"width":475,"blurWidth":0,"blurHeight":0};